import { Button } from "antd";
import React, { FC, useEffect, useState } from "react";
import styles from "./question.module.scss";
import { useIntl } from "react-intl";
import { extractTranslation } from "../../../helpers/formatters";
import { useRouter } from "next/router";
import { QuestionProps } from "../../../pages/form";
import { Maybe } from "graphql/jsutils/Maybe";

interface BoolQuestionProps extends QuestionProps {}

export const BoolQuestion: FC<BoolQuestionProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const { formatMessage } = useIntl();

  const boolQuestion = question?.boolean;
  const boolValue = answer?.value?.boolean?.value;

  const [internalValue, setInternalValue] = useState<boolean | null>();

  useEffect(() => {
    if (boolValue !== internalValue) {
      setInternalValue(boolValue);
    }
  }, [boolValue]);

  const router = useRouter();
  const locale = router.locale;

  const longNoText =
    extractTranslation(boolQuestion?.longNoText, locale) ||
    formatMessage({ id: "no" });
  const longYesText =
    extractTranslation(boolQuestion?.longYesText, locale) ||
    formatMessage({ id: "yes" });

  const nullable = boolQuestion?.nullable;

  function answerQuestion(value: Maybe<boolean> | undefined) {
    setInternalValue(value);
    onAnswer({
      boolean: value === true || value === false ? { value } : { value: null },
    });
  }

  const selectedStyle: React.CSSProperties = {
    backgroundColor: "#1a518a",
    color: "white",
  };

  return (
    <div>
      <Button
        disabled={internalValue === false && !nullable}
        className={styles.radioButton}
        style={internalValue === false ? selectedStyle : undefined}
        onClick={() => {
          if (nullable && internalValue === false) {
            answerQuestion(null);
          } else {
            answerQuestion(false);
          }
        }}
      >
        {longNoText}
      </Button>
      <Button
        disabled={internalValue === true && !nullable}
        className={styles.radioButton}
        style={internalValue === true ? selectedStyle : undefined}
        onClick={() => {
          if (nullable && internalValue === true) {
            answerQuestion(null);
          } else {
            answerQuestion(true);
          }
        }}
      >
        {longYesText}
      </Button>
    </div>
  );
};
